export const AMAZON_PRICE_MAX_AGE_MS = 24 * 60 * 60 * 1000;

export function isAmazonApiOffer(offer) {
  try {
    const url = new URL(offer?.affiliate_url || offer?.['Job Link'] || '');
    return url.hostname === 'www.amazon.com' && url.searchParams.has('tag')
      && ['ogi', 'osi'].includes(url.searchParams.get('linkCode'));
  } catch {
    return false;
  }
}

export function amazonPriceIsExpired(offer, now = Date.now()) {
  if (!isAmazonApiOffer(offer)) return false;
  const checked = new Date(offer.last_success_at || offer.last_checked_at || offer['Date Time Stamp']).getTime();
  return !Number.isFinite(checked) || now - checked >= AMAZON_PRICE_MAX_AGE_MS;
}
